import React, { useEffect } from "react";
import Nav from "./Nav";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";

const Layout = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <div className="layout">
      <Nav />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
